import { useTranslations } from "contexts/LocalizationContext";
import { CheckmarkIcon } from "styles/icons";
import { ChakraFlex as Flex, ChakraText as Text } from "@airhelp/react-ui-components";
import type { InfoCheckmarksProps } from "./InfoCheckmarks.d";

const InfoCheckmarks = ({ checkmarks }: InfoCheckmarksProps) => {
  const translations = useTranslations();

  return (
    <Flex
      gridColumn={{ base: "initial", md: "span 12" }}
      justify={{ base: "space-around", md: "start" }}
      bgRepeat="no-repeat"
      mt={6}
      display={{ base: "none", md: "flex" }}
    >
      {checkmarks.map((element) => (
        <Flex key={element} mr={{ base: 2, md: 5 }} _last={{ mr: 0 }} align="center">
          <CheckmarkIcon mr={2} boxSize={4} color="primary.500" />
          <Text fontSize="sm" letterSpacing="wide" color="greyscale.600">
            {translations(element)}
          </Text>
        </Flex>
      ))}
    </Flex>
  );
};

export default InfoCheckmarks;
